import type { DeepRequired } from '../fixtures.types'

const ledgerFilters: DeepRequired<LedgerFilters> = {
  __typename: 'LedgerFilters',
  advisorIds: [],
  advisors: [],
  clubIds: [],
  clubs: [],
  periodIds: [],
  period_ids: [],
  sourceIds: [],
}

export default ledgerFilters
